<gabarit-global [configuration]="configNavigation">
  <app-spinner></app-spinner>
  <main id="changement-adresse">
    <div [hidden]="isLoading">
      <dsd-grid [class]="isApp ? 'dsd-m-md' : ''">
        <router-outlet></router-outlet>
      </dsd-grid>
    </div>
    <app-modale></app-modale>
  </main>
</gabarit-global>
